const PROPERTY_TYPES = [
    {
        "label": "Residential",
        "keywords": ""
    },
    {
        "label": "House",
        "keywords": "HOUSE`DETACHED"
    },
    {
        "label": "Apartment/Unit",
        "keywords": "APARTMENT/UNIT`"
    },
    {
        "label": "Townhouse",
        "keywords": "TOWNHOUSE`SHARED`WALL`SEMI"
    },
    {
        "label": "Villa",
        "keywords": "VILLA`SHARED`WALL`SEMI"
    },
    {
        "label": "Duplex",
        "keywords": "DUPLEX`SHARED`WALL"
    },
    {
        "label": "Semi-detached/Maisonette",
        "keywords": "SEMI-DETACHED/MAISONETTE`SHARED`WALL"
    },
    {
        "label": "Terrace",
        "keywords": "TERRACE`SHARED`WALL"
    },
    {
        "label": "Dual Occupancy",
        "keywords": "DUAL OCCUPANCY`GRANNY`FLAT"
    },
    {
        "label": "Serviced Apartment/Short Term Rental",
        "keywords": "SERVICED APARTMENT/SHORT TERM RENTAL`"
    },
    {
        "label": "Display Home",
        "keywords": "DISPLAY HOME`"
    },
    {
        "label": "Commercial",
        "keywords": ""
    },
    {
        "label": "Office",
        "keywords": "OFFICE`"
    },
    {
        "label": "Retail",
        "keywords": "RETAIL`"
    },
    {
        "label": "Block of Flats",
        "keywords": "BLOCK OF FLATS`"
    },
    {
        "label": "Boarding House",
        "keywords": "BOARDING HOUSE`"
    },
    {
        "label": "Warehouse",
        "keywords": "WAREHOUSE`"
    },
    {
        "label": "Showroom/Bulky Goods",
        "keywords": "SHOWROOM/BULKY GOODS`"
    },
    {
        "label": "Hotel/Motel",
        "keywords": "HOTEL/MOTEL`AIRBNB`BED`BREAKFAST`ACCOMMODATION`HOSTEL`SHORT TERM ACCOMMODATION"
    },
    {
        "label": "Pub/Tavern or Gaming",
        "keywords": "PUB/TAVERN OR GAMING`ENTERTAINMENT`LEISURE"
    },
    {
        "label": "Medical/Consulting",
        "keywords": "MEDICAL/CONSULTING`"
    },
    {
        "label": "Child Care",
        "keywords": "CHILD CARE`DAYCARE`EARLY`CHILDHOOD`LEARNING"
    },
    {
        "label": "Aged Care",
        "keywords": "AGED CARE`"
    },
    {
        "label": "Vacant Land",
        "keywords": "LAND`VACANT"
    },
    {
        "label": "Development Site",
        "keywords": "DEVELOPMENT SITE"
    },
    /*{
        "label": "Land/Development Site",
        "keywords": "LAND/DEVELOPMENT SITE`VACANT"
    },*/
    {
        "label": "Other",
        "keywords": ""
    },
    {
        "label": "Acreage", "value": "RESIDENTIAL", "keywords": "ACREAGE`"
    },
    {
        "label": "Alpine",
        "keywords": "ALPINE`SNOW"
    },
    {
        "label": "Broad Acre",
        "keywords": "BROAD ACRE`"
    },
    {
        "label": "Car Park",
        "keywords": "CAR PARK`"
    },
    {
        "label": "Car Wash",
        "keywords": "CAR WASH`"
    },
    {
        "label": "Caravan Park",
        "keywords": "CARAVAN PARK`"
    },
    {
        "label": "Caryard",
        "keywords": "CARYARD`"
    },
    {
        "label": "Church/Other Place of Worship",
        "keywords": "CHURCH/OTHER PLACE OF WORSHIP`RELIGION`RELIGIOUS"
    },
    {
        "label": "Cinema",
        "keywords": "CINEMA`ENTERTAINMENT`LEISURE"
    },
    {
        "label": "Club",
        "keywords": "CLUB`ENTERTAINMENT`LEISURE"
    },
    {
        "label": "Commercial Farming",
        "keywords": "COMMERCIAL FARMING`"
    },
    {
        "label": "Company Title Unit", "value": "RESIDENTIAL", "keywords": "COMPANY TITLE UNIT`"
    },
    {
        "label": "Cottage", "value": "RESIDENTIAL", "keywords": "COTTAGE`"
    },
    {
        "label": "Dairy",
        "keywords": "DAIRY`"
    },
    {
        "label": "Day Surgery",
        "keywords": "DAY SURGERY`"
    },
    {
        "label": "Englobo/Pre-development Site",
        "keywords": "ENGLOBO/PRE-DEVELOPMENT SITE`"
    },
    {
        "label": "Extractive Industry/Quarry",
        "keywords": "EXTRACTIVE INDUSTRY/QUARRY`MINING`MINE"
    },
    {
        "label": "Factory",
        "keywords": "FACTORY`"
    },
    {
        "label": "Feedlot",
        "keywords": "FEEDLOT`"
    },
    {
        "label": "Function/Reception Centre",
        "keywords": "FUNCTION/RECEPTION CENTRE`WEDDING"
    },
    {
        "label": "Funeral Parlour",
        "keywords": "FUNERAL PARLOUR`"
    },
    {
        "label": "Golf Course",
        "keywords": "GOLF COURSE`ENTERTAINMENT`LEISURE`SPORTS"
    },
    {
        "label": "Grazing/Cropping",
        "keywords": "GRAZING/CROPPING`"
    },
    {
        "label": "Guest House/Backpacker",
        "keywords": "GUEST HOUSE/BACKPACKER`AIRBNB`BED`BREAKFAST`ACCOMMODATION`HOSTEL`SHORT TERM ACCOMMODATION"
    },
    {
        "label": "Health Care",
        "keywords": "HEALTH CARE`"
    },
    {
        "label": "Holiday Accommodation",
        "keywords": "HOLIDAY ACCOMMODATION`AIRBNB`BED`BREAKFAST"
    },
    {
        "label": "Horticulture",
        "keywords": "HORTICULTURE`"
    },
    {
        "label": "Hospital",
        "keywords": "HOSPITAL`"
    },
    {
        "label": "Housing Co-operative", "value": "RESIDENTIAL", "keywords": "HOUSING CO-OPERATIVE`"
    },
    {
        "label": "Industrial",
        "keywords": "INDUSTRIAL`"
    },
    {
        "label": "Irrigation",
        "keywords": "IRRIGATION`"
    },
    {
        "label": "Large Retail Centre",
        "keywords": "LARGE RETAIL CENTRE`"
    },
    {
        "label": "Leaseback",
        "keywords": "LEASEBACK`"
    },
    {
        "label": "Leasehold",
        "keywords": "LEASEHOLD`"
    },
    {
        "label": "Lifestyle", "value": "RESIDENTIAL", "keywords": "LIFESTYLE`"
    },
    {
        "label": "Management Letting Rights",
        "keywords": "MANAGEMENT LETTING RIGHTS`"
    },
    {
        "label": "Manufactured Home Estate",
        "keywords": "MANUFACTURED HOME ESTATE`MANUFACTURED HOME PARK"
    },
    {
        "label": "Marina",
        "keywords": "MARINA`"
    },
    {
        "label": "Mechanical Workshop",
        "keywords": "MECHANICAL WORKSHOP`AUTOMOTIVE"
    },
    {
        "label": "Mixed Use",
        "keywords": "MIXED USE`"
    },
    {
        "label": "Orchard",
        "keywords": "ORCHARD`"
    },
    {
        "label": "Pastoral",
        "keywords": "PASTORAL`"
    },
    {
        "label": "Piggery",
        "keywords": "PIGGERY`"
    },
    {
        "label": "Poultry",
        "keywords": "POULTRY`"
    },
    {
        "label": "Rent Roll",
        "keywords": "RENT ROLL`"
    },
    {
        "label": "Rental Guarantee",
        "keywords": "RENTAL GUARANTEE`"
    },
    {
        "label": "Retirement Living",
        "keywords": "RETIREMENT LIVING`SENIORS"
    },
    {
        "label": "Rural",
        "keywords": "RURAL`REGIONAL"
    },
    {
        "label": "School",
        "keywords": "SCHOOL`EDUCATION`UNIVERSITY`COLLEGE"
    },
    {
        "label": "Self Storage",
        "keywords": "SELF STORAGE`LOCKER"
    },
    {
        "label": "Service Station",
        "keywords": "SERVICE STATION`PETROL"
    },
    {
        "label": "Shack/Holiday Home", "value": "RESIDENTIAL", "keywords": "SHACK/HOLIDAY HOME`"
    },
    {
        "label": "Shopping Centre",
        "keywords": "SHOPPING CENTRE`"
    },
    {
        "label": "Specialised Agriculture",
        "keywords": "SPECIALISED AGRICULTURE`"
    },
    {
        "label": "Student Accommodation", "value": "RESIDENTIAL", "keywords": "STUDENT ACCOMMODATION`"
    },
    {
        "label": "Sugar Cane",
        "keywords": "SUGAR CANE`"
    },
    {
        "label": "Timeshare",
        "keywords": "TIMESHARE`"
    },
    {
        "label": "Vineyard",
        "keywords": "VINEYARD`"
    },
    {
        "label": "Viticulture",
        "keywords": "VITICULTURE`"
    }
]

const ACTION_COLOURS = {
    'ACCEPT':'rgba(17, 185, 121, 1)',
    'REVIEW AFTER PAID':'rgba(252, 237, 100, 1)', //'rgba(17, 185, 121, 1)',
    'REVIEW':'rgba(252, 237, 100, 1)',
    'REJECT':'rgba(230, 38, 61, 1)',
}

const CERT_COLOURS = {
    'Valid':'rgba(17, 185, 121, 1)',
    'Registered':'rgba(17, 185, 121, 1)',
    'Active':'rgba(17, 185, 121, 1)',
    'Expired':'rgba(252, 237, 100, 1)',
    'Missing':'rgba(230, 38, 61, 1)',
    'Non-compliance':'rgba(230, 38, 61, 1)',
    'Non-Compliant':'rgba(230, 38, 61, 1)',
}

const SWIMMING_POOL_PROPERTY_TYPES = [
    'House',
    'Townhouse',
    'Villa',
    'Duplex',
    'Semi-detached/Maisonette',
    'Terrace',
    'Dual Occupancy',
    'Display Home',
    'Acreage',
    'Cottage',
    'Shack/Holiday Home',
]

const COLOUR_MAPS = {
    G: '#11b979cc',
    Y: '#fced64cc',
    R: '#e6263dcc',
    X: '#404040cc',
    "Metro": '#11b979cc',
    "Inner City": '#11b979cc',
    "Non-Metro": '#fced64cc',
    "Unlisted": '#e6263dcc',
  };

export { 
    PROPERTY_TYPES,
    ACTION_COLOURS,
    CERT_COLOURS,
    SWIMMING_POOL_PROPERTY_TYPES,
    COLOUR_MAPS,
}